<template>
  <Card>
    <div class="py-[24px] px-[48px] lg:pt-[24px] lg:pb-[72px] lg:py-0 lg:px-[48px] overflow-hidden seo-block">
      <MDC :value="text"
           tag="div"
           class="font-nutino text-[18px] lg:text-[18px] seo-text mb-4"
           :class="{'is-active': visibleText, 'text-white': variant === 'dark', 'text-black': variant === 'light'}"
      />
      <span class="cursor-pointer hover:underline font-bold"
            :class="{'text-white': variant === 'dark', 'text-black': variant === 'light'}"
            v-if="!visibleText"
            @click="triggerBtn"
      >
        {{ $t('meclee-ui.app.show_seo') }}
      </span>
      <span class="cursor-pointer hover:underline font-bold"
            :class="{'text-white': variant === 'dark', 'text-black': variant === 'light'}"
            v-else
            @click="triggerBtn"
      >
        {{ $t('meclee-ui.app.hide_seo') }}
      </span>
    </div>
  </Card>
</template>

<script setup lang="ts">
import Card from '~/components/ui/Card.vue';
const { locale } = useI18n();

type TVariant = 'dark' | 'light';

interface Props {
  variant?: TVariant
}
withDefaults(defineProps<Props>(), {
  variant: 'dark',
});

const text = ref();
onBeforeMount(async () => {
  if (locale.value === 'uk') {
    const {markdown} = await import('~/content/seo/index.md');
    text.value = markdown;
  } else if (locale.value === 'en') {
    const {markdown} = await import('~/content/seo/en/index.md');
    text.value = markdown;
  }
})

const visibleText = ref(false)
const triggerBtn = () => visibleText.value = !visibleText.value
</script>

<style lang="scss">
.seo-block {
  * {
    @apply text-sm;
  }

  h3 {
    @apply font-bold text-lg mb-4;

    &:not(:first-child) {
      @apply mt-6;
    }
  }

  ul {
    @apply list-disc;

    li {
      @apply ml-4;
    }
  }

  .seo-text {
    &:not(.is-active) {
      max-height: 310px;
      overflow: hidden;
    }
  }
}
</style>/

